/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import ProgressPhotoUpload from './ProgressPhotoUpload';

function ProgressPhotosForm({ setValue }) {
  return (
    <div className="photos-list">
      <ProgressPhotoUpload setValue={setValue} label="Front" name="front" />
      <ProgressPhotoUpload setValue={setValue} label="Side" name="side" />
      <ProgressPhotoUpload setValue={setValue} label="Back" name="back" />
    </div>
  );
}

export default ProgressPhotosForm;
